// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNil = (value: any) => [null, undefined].includes(value);
